import Nav from "../components/Nav";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import PageShell from "../components/marketing/PageShell";
import PageHero from "../components/marketing/PageHero";
import CTAStrip from "../components/marketing/CTAStrip";
import StepCard from "../components/marketing/StepCard";
import { STEPS } from "../data/steps";

export default function HowItWorksPage() {
  return (
    <PageShell testid="page-how">
      <SEO
        title="How It Works"
        description="From uploading a video to receiving your review — how BRep connects you with a qualified coach in four simple steps."
        path="/how-it-works"
      />
      <Nav />
      <PageHero
        eyebrow="How It Works"
        title="Four steps."
        titleAccent="No subscription."
        subtitle="You pick the service, we match you with a qualified coach, you get back a review or a plan you can act on immediately."
      />
      <section className="px-6 md:px-12 py-8 md:py-16">
        <div className="max-w-[1600px] mx-auto border-t border-white/10">
          {STEPS.map((s, i) => (
            <StepCard key={s.n} step={s} index={i} />
          ))}
        </div>
      </section>
      <CTAStrip
        title="Try it once. Come back only when you need to."
        primary={{ to: "/services", label: "View Services" }}
        secondary={{ to: "/download", label: "Download App" }}
      />
      <Footer />
    </PageShell>
  );
}
